import { render, staticRenderFns } from "./MedicineDetails.vue?vue&type=template&id=34ca4204&scoped=true&lang=pug&"
import script from "./MedicineDetails.vue?vue&type=script&lang=js&"
export * from "./MedicineDetails.vue?vue&type=script&lang=js&"
import style0 from "./MedicineDetails.vue?vue&type=style&index=0&id=34ca4204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ca4204",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
